var render, staticRenderFns
import script from "./AdminDirectoryHighlight.vue?vue&type=script&lang=js"
export * from "./AdminDirectoryHighlight.vue?vue&type=script&lang=js"
import style0 from "./AdminDirectoryHighlight.vue?vue&type=style&index=0&id=8fc1324a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc1324a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8fc1324a')) {
      api.createRecord('8fc1324a', component.options)
    } else {
      api.reload('8fc1324a', component.options)
    }
    
  }
}
component.options.__file = "resources/js/components/AdminDirectoryHighlight.vue"
export default component.exports